export const selectDevice = (state) => state.general.device;
export const selectSalePageURL = (state) => state.general.salePageURL;
export const selectGeolocation = (state) => state.general.geolocation.data;
